<template>
  <div class="container" :class="verticalOrientationCheck">
    <OffersCard v-for="(offer, index) in offers" :key="offer.offerCode" :offer="offer" :position="globalPosition + index"/>
  </div>
</template>

<script>
import OffersCard from "@/features/offers/OffersCard.vue";
import {mapGetters} from "vuex";
export default {
  name: "OffersContainer",
  components: {OffersCard},
  props:{
    offers:{
      type: Array,
      required: true
    },
    globalPosition: {
      type: Number,
      default: 0
    }
  },
  computed:{
    ...mapGetters('screen', ["flyerOrientation","displayMode"]),
    verticalOrientationCheck(){
      return {
        'dVertical': this.flyerOrientation==='vertical' && (this.displayMode==='desktop' || this.displayMode==='tablet'),
        'vertical': this.flyerOrientation==='vertical' && this.displayMode==='mobile'
      }
    }
  }

}
</script>

<style scoped>
.container{
  justify-content: space-between;
  display: grid;
  grid-template-columns: repeat(3, 140px);
  row-gap: 0.5em;
}
.container.vertical{
  grid-template-columns: repeat(2,208px);
  column-gap: 0.8em;
}
.container.dVertical{
  grid-template-columns: repeat(3,200px);
  column-gap: 0.75em;
  row-gap: 0.5em;
  margin: 8px;
}

</style>